import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import React from 'react';
import { useI18n } from "./WithI18n.mjs";
var interpolationRegex = /{(.*?)}/g;
var escapeHtml = function escapeHtml(html) {
  return String(html).split('').map(function (_char) {
    switch (_char) {
      case '<':
        return '&lt;';
      case '>':
        return '&gt;';
      case '&':
        return '&amp;';
      case '"':
        return '&quot;';
      case '`':
        return '&#x60';
    }
    return _char;
  }).join('');
};
export function interpolate(template) {
  var variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return template.replace(interpolationRegex, function (_, key) {
    if (variables[key] !== undefined) {
      return escapeHtml(variables[key]);
    }
    return _;
  });
}

/** @deprecated */

export var useAsyncI18nMessages = function useAsyncI18nMessages(primaryContainer, locale, fallbackContainer) {
  var _store$locale;
  var container = React.useMemo(function () {
    if (!fallbackContainer) return primaryContainer;
    if (!primaryContainer) return fallbackContainer;
    if (primaryContainer === fallbackContainer) return primaryContainer;
    var container = {};
    var _loop = function _loop(_locale) {
      if (typeof primaryContainer[_locale] === 'function' || typeof fallbackContainer[_locale] === 'function') {
        container[_locale] = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var _yield$Promise$all, _yield$Promise$all2, primary, fallback;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Promise.all([primaryContainer[_locale], fallbackContainer[_locale]]);
              case 2:
                _yield$Promise$all = _context.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                primary = _yield$Promise$all2[0];
                fallback = _yield$Promise$all2[1];
                return _context.abrupt("return", _objectSpread(_objectSpread({}, primary), fallback));
              case 7:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
      } else {
        var _primaryContainer$_lo, _fallbackContainer$_l;
        container[_locale] = _objectSpread(_objectSpread({}, (_primaryContainer$_lo = primaryContainer[_locale]) !== null && _primaryContainer$_lo !== void 0 ? _primaryContainer$_lo : {}), (_fallbackContainer$_l = fallbackContainer[_locale]) !== null && _fallbackContainer$_l !== void 0 ? _fallbackContainer$_l : {});
      }
    };
    for (var _locale in primaryContainer) {
      _loop(_locale);
    }
    return container;
  }, [primaryContainer, fallbackContainer]);
  var initStore = React.useMemo(function () {
    var store = {};
    for (var _locale2 in container) {
      if (_typeof(container[_locale2]) === 'object') {
        store[_locale2] = container[_locale2];
      }
    }
    return store;
  }, [container]);
  var _React$useState = React.useState(initStore),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    store = _React$useState2[0],
    setStore = _React$useState2[1];
  var lastLoadedLocaleRef = React.useRef(null);
  if (store[locale]) lastLoadedLocaleRef.current = locale;
  var fallbackMessages = React.useMemo(function () {
    return Object.values(store)[0];
  }, [store]);
  var loadingLocaleRef = React.useRef(null);
  React.useEffect(function () {
    loadingLocaleRef.current = locale;
    var asyncMessages = container[locale];
    if (typeof asyncMessages === 'function') {
      asyncMessages().then(function (module) {
        if (loadingLocaleRef.current !== locale) return;
        var messages = module;
        if ('default' in module && _typeof(module["default"]) === 'object') messages = module["default"];
        setStore(function (store) {
          return _objectSpread(_objectSpread({}, store), {}, _defineProperty({}, locale, messages));
        });
      })["catch"](console.error);
    }
  }, [container, locale]);
  return (_store$locale = store[locale]) !== null && _store$locale !== void 0 ? _store$locale : fallbackMessages;
};
export default (function (container) {
  return function (props) {
    var i18n = props.i18n,
      locale = props.locale;
    var getI18nText = useI18n(i18n, locale, container);
    return _objectSpread(_objectSpread({}, props), {}, {
      getI18nText: getI18nText
    });
  };
});
//# sourceMappingURL=i18nEnhance.mjs.map